import type { ReactNode } from 'react';
import type { IconProps } from 'components/Icon';

import styles from './InfoBanner.module.css';

import { Icon } from 'components/Icon';

export interface InfoBannerProps {
  /** The name of the icon to display in the banner. */
  iconName?: IconProps['name'];
  /** Content or message as sting or react component. */
  content?: string | ReactNode;
}

export const InfoBanner = ({ iconName, content }: InfoBannerProps) => {
  return (
    <div className={styles['infobanner_wrapper']}>
      {iconName && <Icon name={iconName} size={24} />}
      {content}
    </div>
  );
};
